"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _importWarehouse = require("@/api/import-warehouse");
var _vuePropertyDecorator = require("vue-property-decorator");
var _ImportProductOrderForm = _interopRequireDefault(require("./ImportProductOrderForm.vue"));
var _moment = _interopRequireDefault(require("moment"));
var _lodash = require("lodash");
var _ImportWarehousePrint = _interopRequireDefault(require("./ImportWarehousePrint.vue"));
var _ImportPrintInformationForm = _interopRequireDefault(require("./ImportPrintInformationForm.vue"));
var OrderModal = /*#__PURE__*/function (_Vue) {
  function OrderModal() {
    var _this;
    (0, _classCallCheck2.default)(this, OrderModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, OrderModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {
      products: []
    });
    (0, _defineProperty2.default)(_this, "status", "create");
    (0, _defineProperty2.default)(_this, "orderStatus", "");
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "orderProgress", {});
    return _this;
  }
  (0, _inherits2.default)(OrderModal, _Vue);
  return (0, _createClass2.default)(OrderModal, [{
    key: "handleDelete",
    value: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$confirm("Confirm delete import", "Warning", {
                cancelButtonText: "No",
                confirmButtonText: "Delete",
                type: "warning"
              });
            case 2:
              _context.prev = 2;
              this.loading = true;
              _context.next = 6;
              return _importWarehouse.importWarehouseApi.delete(this.form.id);
            case 6:
              this.$emit("submit:ok");
              this.visible = false;
              this.$notify.success({
                title: "Delete import",
                message: "Successfully"
              });
            case 9:
              _context.prev = 9;
              this.loading = false;
              return _context.finish(9);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2,, 9, 12]]);
      }));
      function handleDelete() {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }()
  }, {
    key: "handlePrint",
    value: function handlePrint() {
      this.$refs.printMe.handlePrint();
    }
    // check validate data
  }, {
    key: "checkValidate",
    value: function () {
      var _checkValidate = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var _this2 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(resolve, reject) {
                  return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.prev = 0;
                        _context2.next = 3;
                        return _this2.$refs.product.$refs.form.validate();
                      case 3:
                        _context2.next = 9;
                        break;
                      case 5:
                        _context2.prev = 5;
                        _context2.t0 = _context2["catch"](0);
                        _this2.$message.error("Fill correct all input");
                        return _context2.abrupt("return", reject());
                      case 9:
                        if (_this2.form.products.length) {
                          _context2.next = 12;
                          break;
                        }
                        _this2.$message.error("Products least 1 item!");
                        return _context2.abrupt("return", reject());
                      case 12:
                        if (!_this2.form.products.some(function (e) {
                          return (0, _lodash.isEmpty)(e.lotNumber) || !e.expired || !e.dateOfManufacture;
                        })) {
                          _context2.next = 15;
                          break;
                        }
                        _this2.$message.error("Products must have lot number, expired and manufacture date");
                        return _context2.abrupt("return", reject());
                      case 15:
                        resolve();
                      case 16:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2, null, [[0, 5]]);
                }));
                return function (_x, _x2) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function checkValidate() {
        return _checkValidate.apply(this, arguments);
      }
      return checkValidate;
    }()
  }, {
    key: "createData",
    value: function () {
      var _createData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var _this3 = this;
        var form, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.checkValidate();
            case 2:
              form = (0, _objectSpread2.default)({}, this.form);
              delete form.products;
              data = {
                importWarehouse: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, form), {}, {
                  date: form.date / 1000
                }),
                details: this.form.products.map(function (e) {
                  return {
                    quantity: e.importQuantity,
                    productId: e.id,
                    expired: e.expired / 1000,
                    dateOfManufacture: (0, _moment.default)(e.dateOfManufacture).unix(),
                    lotNumber: e.lotNumber
                  };
                }),
                staffId: this.form.staffId
              };
              this.loading = true;
              _importWarehouse.importWarehouseApi.create(data).then(function () {
                _this3.$notify.success({
                  title: "New import warehouse",
                  message: "Successfully"
                });
                _this3.$emit("submit:ok");
                _this3.visible = false;
              }).finally(function () {
                return _this3.loading = false;
              });
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function createData() {
        return _createData.apply(this, arguments);
      }
      return createData;
    }()
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5() {
        var form;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return this.checkValidate();
            case 3:
              this.loading = true;
              form = (0, _objectSpread2.default)({}, this.form);
              _context5.next = 7;
              return _importWarehouse.importWarehouseApi.update(this.form.id, {
                importWarehouse: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, form), {}, {
                  date: form.date / 1000
                }),
                staffId: this.form.staffId
              });
            case 7:
              _context5.next = 9;
              return this.updateDetail();
            case 9:
              this.visible = false;
              this.$notify({
                title: "Update import warehouse",
                message: "Successfully",
                type: "success"
              });
              this.$emit("submit:ok");
            case 12:
              _context5.prev = 12;
              this.loading = false;
              return _context5.finish(12);
            case 15:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0,, 12, 15]]);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "updateDetail",
    value: function () {
      var _updateDetail = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6() {
        var i, e, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              i = 0;
            case 1:
              if (!(i < this.form.products.length)) {
                _context6.next = 14;
                break;
              }
              e = this.form.products[i];
              data = {
                quantity: e.importQuantity,
                productId: e.id,
                expired: e.expired / 1000,
                dateOfManufacture: (0, _moment.default)(e.dateOfManufacture).unix(),
                lotNumber: e.lotNumber
              };
              if (e.detailId) {
                _context6.next = 9;
                break;
              }
              _context6.next = 7;
              return _importWarehouse.importWarehouseApi.addDetail(this.form.id, {
                detail: data
              });
            case 7:
              _context6.next = 11;
              break;
            case 9:
              _context6.next = 11;
              return _importWarehouse.importWarehouseApi.updateDetailQuantity(e.detailId, {
                quantity: e.importQuantity,
                expired: e.expired / 1000,
                dateOfManufacture: (0, _moment.default)(e.dateOfManufacture).unix(),
                lotNumber: e.lotNumber
              });
            case 11:
              i++;
              _context6.next = 1;
              break;
            case 14:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function updateDetail() {
        return _updateDetail.apply(this, arguments);
      }
      return updateDetail;
    }()
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.visible = true;
      this.status = "create";
      this.form = {
        products: [],
        date: (0, _moment.default)().valueOf()
      };
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(data) {
      this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        products: data.importWarehouseDetails.map(function (e) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, e), {}, {
            id: e.product.id,
            productGalleries: e.product.productGalleries,
            name: e.product.name,
            detailId: e.id,
            quantity: e.product.quantity,
            importQuantity: e.quantity,
            remainQuantity: e.product.quantity,
            expired: e.expired * 1000,
            dateOfManufacture: _moment.default.unix(e.dateOfManufacture).valueOf(),
            lotNumber: e.lotNumber
          });
        }),
        staffId: data.staff && data.staff.id,
        date: data.date * 1000
      });
      this.visible = true;
      this.status = "update";
      this.orderStatus = data.orderStatus;
    }
  }]);
}(_vuePropertyDecorator.Vue);
OrderModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ProductOrderForm: _ImportProductOrderForm.default,
    ImportWarehousePrint: _ImportWarehousePrint.default,
    ImportPrintInformationForm: _ImportPrintInformationForm.default
  }
})], OrderModal);
var _default = exports.default = OrderModal;